module.exports = __webpack_public_path__ + "593a3d53/img/file-icon.c085e21e.svg";